"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinneList = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const fuehrungsrinne_1 = require("./fuehrungsrinne");
/**
 * The `FuehrungsrinneList` manages a list of `Fuehrungsrinne`
 */
class FuehrungsrinneList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new FuehrungsrinneList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new FuehrungsrinneList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(json) {
        const list = new FuehrungsrinneList();
        list.fromModel(json);
        return list;
    }
    static fromArray(arr) {
        const list = new FuehrungsrinneList();
        list.fromArray(arr);
        return list;
    }
    static fromExistingArtNr(json, cloneStrategy = 'deep') {
        const list = new FuehrungsrinneList();
        list.fromExistingArtNr(json, cloneStrategy);
        return list;
    }
    static fromInventedArtNr(json, cloneStrategy = 'deep') {
        const list = new FuehrungsrinneList();
        list.fromInventedArtNr(json, cloneStrategy);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = json.map((j) => fuehrungsrinne_1.Fuehrungsrinne.fromJson(j, cloneStrategy));
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        this.items = model.map((m) => fuehrungsrinne_1.Fuehrungsrinne.fromModel(m));
        this.model = model;
        this.emitChange();
    }
    fromExistingArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(fuehrungsrinne_1.Fuehrungsrinne.fromExistingArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    fromInventedArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(fuehrungsrinne_1.Fuehrungsrinne.fromInventedArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    clone() {
        return FuehrungsrinneList.fromArray(this.items.map((i) => i.clone()));
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * Retrieves the cumulated weight of all Fuehrungsrinnen in the list.
     *
     * @returns The weight.
     */
    getCumulatedWeight() {
        return echain_shared_quantities_1.Weight.kg(this.items.reduce((cumulatedWeight, fuehrungsrinne) => cumulatedWeight + (fuehrungsrinne.gewicht ? fuehrungsrinne.gewicht.kg : 0), 0));
    }
    /**
     * Returns a new list with FuehrungsrinneList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return FuehrungsrinneList.fromArray(this.items.filter((article) => article.localizedArtNr && article.localizedArtNr[artNrCountry]));
    }
}
exports.FuehrungsrinneList = FuehrungsrinneList;
//# sourceMappingURL=fuehrungsrinne-list.js.map